import { ConnectUiState } from '../../../../@types';

const initialState: ConnectUiState = {
  selectedCar: null,
  selectedDevice: null,
  selectedDeviceStatus: null,
};
export default initialState;
